<template>
  <div class="bl">
    <div class="text-center superCenter">
      <v-progress-circular indeterminate size="32"></v-progress-circular>
    </div>
  </div>
</template>

<script>
export default {
  name: "BoxLoading",
  // props: {
  //   preventClick: {
  //     default: false,
  //     type: Boolean
  //   },
  // },
  // methods: {
  //   handleClick() {
  //
  //   },
  // }
}
</script>

<style scoped lang="scss">
.bl {
  z-index: 2200;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: all;
  background-color: rgba(black, 0.7);
  color: white;
}
</style>
